import {useQuery} from '@tanstack/react-query'
import {useParams} from 'react-router-dom'

import Breadcrumb from '../../Components/Common/Breadcrumb'
import {GetProduct} from '../../infra/requests/ProductsRequests'
import {ArticlesDetailsForm} from './components/article-details-form/ArticleDetailsForm'
import {formatProductForForm} from './components/article-details-form/utils/formatProductForForm'
import {FormDirtyProvider} from './contexts/FormDirtyContext'
import './styles.scss'

const ArticlesDetails = () => {
  const {productId} = useParams()

  const {data: productData, isFetching} = useQuery({
    queryKey: [`productDetialsId:${productId}`, productId],
    queryFn: ({signal}) => GetProduct(productId, signal)
  })

  const breadcrumbData = {
    pageTitle: 'Article Detail',
    items: [{title: 'Articles', url: '/articles'}, {title: 'Article Detail'}]
  }

  const initialProviderValues = productData?.data
    ? formatProductForForm(productData.data)
    : {}

  return (
    <div className="page-content">
      <div className="breadcrumb-bar">
        <Breadcrumb breadcrumbData={breadcrumbData} />
      </div>
      <FormDirtyProvider initialFormValues={initialProviderValues}>
        <ArticlesDetailsForm
          isLoading={isFetching}
          product={productData?.data}
        />
      </FormDirtyProvider>
    </div>
  )
}

export default ArticlesDetails
